!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.ce = t());
}(this, function () {
  "use strict";

  return [{
    locale: "ce",
    pluralRuleFunction: function (e, t) {
      return t ? "other" : 1 == e ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "шо",
        relative: {
          0: "карарчу шарахь",
          1: "рогӀерчу шарахь",
          "-1": "даханчу шарахь"
        },
        relativeTime: {
          future: {
            one: "{0} шо даьлча",
            other: "{0} шо даьлча"
          },
          past: {
            one: "{0} шо хьалха",
            other: "{0} шо хьалха"
          }
        }
      },
      "year-short": {
        displayName: "ш.",
        relative: {
          0: "карарчу шарахь",
          1: "рогӀерчу шарахь",
          "-1": "даханчу шарахь"
        },
        relativeTime: {
          future: {
            one: "{0} ш. даьлча",
            other: "{0} ш. даьлча"
          },
          past: {
            one: "{0} ш. хьалха",
            other: "{0} ш. хьалха"
          }
        }
      },
      month: {
        displayName: "бутт",
        relative: {
          0: "карарчу баттахь",
          1: "рогӀерчу баттахь",
          "-1": "баханчу баттахь"
        },
        relativeTime: {
          future: {
            one: "{0} бутт баьлча",
            other: "{0} бутт баьлча"
          },
          past: {
            one: "{0} бутт хьалха",
            other: "{0} бутт хьалха"
          }
        }
      },
      "month-short": {
        displayName: "бут.",
        relative: {
          0: "карарчу баттахь",
          1: "рогӀерчу баттахь",
          "-1": "баханчу баттахь"
        },
        relativeTime: {
          future: {
            one: "{0} б. баьлча",
            other: "{0} б. баьлча"
          },
          past: {
            one: "{0} б. хьалха",
            other: "{0} б. хьалха"
          }
        }
      },
      day: {
        displayName: "де",
        relative: {
          0: "тахана",
          1: "кхана",
          "-1": "селхана"
        },
        relativeTime: {
          future: {
            one: "{0} де даьлча",
            other: "{0} де даьлча"
          },
          past: {
            one: "{0} де хьалха",
            other: "{0} де хьалха"
          }
        }
      },
      "day-short": {
        displayName: "де",
        relative: {
          0: "тахана",
          1: "кхана",
          "-1": "селхана"
        },
        relativeTime: {
          future: {
            one: "{0} д. даьлча",
            other: "{0} д. даьлча"
          },
          past: {
            one: "{0} д. хьалха",
            other: "{0} де хьалха"
          }
        }
      },
      hour: {
        displayName: "сахьт",
        relative: {
          0: "хӀокху сахьтехь"
        },
        relativeTime: {
          future: {
            one: "{0} сахьт даьлча",
            other: "{0} сахьт даьлча"
          },
          past: {
            one: "{0} сахьт хьалха",
            other: "{0} сахьт хьалха"
          }
        }
      },
      "hour-short": {
        displayName: "сахь.",
        relative: {
          0: "хӀокху сахьтехь"
        },
        relativeTime: {
          future: {
            one: "{0} сахь. даьлча",
            other: "{0} сахь. даьлча"
          },
          past: {
            one: "{0} сахь. хьалха",
            other: "{0} сахь. хьалха"
          }
        }
      },
      minute: {
        displayName: "минот",
        relative: {
          0: "хӀокху минотехь"
        },
        relativeTime: {
          future: {
            one: "{0} минот яьлча",
            other: "{0} минот яьлча"
          },
          past: {
            one: "{0} минот хьалха",
            other: "{0} минот хьалха"
          }
        }
      },
      "minute-short": {
        displayName: "мин.",
        relative: {
          0: "хӀокху минотехь"
        },
        relativeTime: {
          future: {
            one: "{0} мин. яьлча",
            other: "{0} мин. яьлча"
          },
          past: {
            one: "{0} мин. хьалха",
            other: "{0} мин. хьалха"
          }
        }
      },
      second: {
        displayName: "секунд",
        relative: {
          0: "хӀинца"
        },
        relativeTime: {
          future: {
            one: "{0} секунд яьлча",
            other: "{0} секунд яьлча"
          },
          past: {
            one: "{0} секунд хьалха",
            other: "{0} секунд хьалха"
          }
        }
      },
      "second-short": {
        displayName: "сек.",
        relative: {
          0: "хӀинца"
        },
        relativeTime: {
          future: {
            one: "{0} сек. яьлча",
            other: "{0} сек. яьлча"
          },
          past: {
            one: "{0} сек. хьалха",
            other: "{0} сек. хьалха"
          }
        }
      }
    }
  }];
});